module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet c, cd, category, categoryData, aT, childCategoryDataID, categoryAdditionalClasses, categoryDataAdditionalClasses, assignedTagAttributes, selected, childSelected, dirty, childDirty, showOption, dirtyTag, dirtyTagID\nlet turnedOff, turnedOn, turnedOffByInheritance\nlet preparedAssignedTag\nlet level, lastLevel, l\n// TODO: remove lse specifics from fec base component\nconst showTagNumbers = helpers.hasAccessTo('usage:show_lse_tag_numbers', 'literature')\nconst managementGranted = {\ncategory: \t\thelpers.hasAccessTo('cms_categories:create'),\ncategoryData: \thelpers.hasAccessTo('cms_categoriesData:create'),\n}\nconst additionalClasses = []\nif(resourceData.useNormalDirtyColor){\nadditionalClasses.push('dirtyColorNormal')\n}\nif(config.isEnhanced !== false){\nadditionalClasses.push('isEnhanced')\n} else {\nadditionalClasses.push('isNotEnhanced')\n}\nif(!resourceData.selectParentsGranted) {\nadditionalClasses.push('preventSelectParents')\n}\nconst supportCollapsibleTags \t= resourceData.supportCollapsibleTags === true\nconst maxOpenLevelOnInit \t\t= resourceData.maxOpenLevelOnInit || 1\n%><div class=\"<%= additionalClasses.join(' ') %>\"><%\nif(config.isEnhanced !== false){\n%><%- helpers.renderSection('enhanced') %><%\n}\n%><section class=\"tagsOnly\"><%\n%><%- helpers.renderSection('filter') %><%\n%><section class=\"content\"><%\nfor(c in resourceData.options || []) {\ncategory = resourceData.options[c]\ncategoryAdditionalClasses = []\nif(resourceData.preparedAssignedCategories[category.id]){\npreparedAssignedTag = resourceData.preparedAssignedCategories[category.id]\nturnedOff = preparedAssignedTag.turnedOff\nturnedOn = preparedAssignedTag.turnedOn\nturnedOffByInheritance = preparedAssignedTag.turnedOffByInheritance\n} else {\npreparedAssignedTag = { noData: true }\nturnedOff = false\nturnedOn = false\nturnedOffByInheritance = (resourceData.inheritedCategories || {})[category.id] === false\n}\ndirty = false\nselected = !turnedOff && (!turnedOffByInheritance || turnedOn)\ninherited = !turnedOff && !turnedOn\nshowOption = resourceData.optionalCategories && model.turnedOffTagCategoryManagementGranted\n// check if categoryData is selected by dirty resources\nif((dirtyTag = model.dirtyAssignedTags[`${category.id}_null`])){\ndirty = true\nselected = !selected\n}\nif(selected) \tcategoryAdditionalClasses.push('selected');\nif(dirty) \t\tcategoryAdditionalClasses.push('dirty');\nif(showOption) \tcategoryAdditionalClasses.push('showOption');\nif(inherited) \tcategoryAdditionalClasses.push('inherited');\nif((!turnedOff && !turnedOffByInheritance) || model.turnedOffTagCategoryManagementGranted){\n%><div class=\"category <%= categoryAdditionalClasses.join(' ') %>\" data-category-id=\"<%- category.id %>\" data-category-data-id=\"null\"><%\n%><i class=\"unselected fi fi-tagFamily-unselected\"></i><%\n%><i class=\"selected fi fi-tagFamily-selected\"></i><%\n%><i class=\"inherited fi fi-tagFamily-inherited\"></i><%\n%><%= category.name %><%= (showTagNumbers ? ' [' + category.id + ']' : '') %><%\nif(managementGranted.categoryData){\n%><%- include('./tagCategoryAddCategoryDataButton', { model: { categoryID: category.id }}) %><%\n}\nif(managementGranted.categoryData){\n%><%- include('./tagCategoryManagementButton', { model: { categoryID: category.id }}) %><%\n}\n%></div><%\nlastLevel = undefined\nfor(cd in category.children || []) {\ncategoryData = category.children[cd]\ncategoryDataAdditionalClasses = []\ndirtyTagID = `${category.id}_${categoryData.id}`\nselected = false\nchildSelected = false\ndirty = false\nchildDirty = false\n// check if categoryData is selected by resources\nfor(aT in resourceData.assignedTags || []) {\nassignedTagAttributes = (resourceData.assignedTags[aT] || {}).attributes || {}\nif(assignedTagAttributes.categoryID === category.id){\n// check if one of the children is selected or not\nif(!childSelected){\nfor(childCategoryDataID in categoryData.children){\nif(assignedTagAttributes.categoryDataID == childCategoryDataID){\nchildSelected = true\nbreak\n}\n}\n}\nif(assignedTagAttributes.categoryDataID === categoryData.id){\nselected = true\nif(childSelected){\nbreak\n}\n}\n}\n}\n// check if categoryData is selected by dirty resources\nif((dirtyTag = model.dirtyAssignedTags[dirtyTagID])){\ndirty = true\nselected = dirtyTag.type !== 'delete'\n}\n// check if one of the children is dirty or not\nfor(childCategoryDataID in categoryData.children){\nif(model.dirtyAssignedTags[`${category.id}_${childCategoryDataID}`]){\nchildDirty = true\nbreak\n}\n}\nif(selected) \tcategoryDataAdditionalClasses.push('selected');\nif(dirty) \t\tcategoryDataAdditionalClasses.push('dirty');\nlevel = categoryData.level || 0\nif(lastLevel){\nif(lastLevel > level) {\nfor(l = lastLevel; l > level; l--){\n%></div><%\n}\n} else if(lastLevel < level) {\n%><div class=\"categoryDataContainer\"><%\n}\n}\nif(supportCollapsibleTags){\n// check if next container should be collapsed\nif(maxOpenLevelOnInit <= level && !childDirty && !childSelected){\ncategoryDataAdditionalClasses.push('collapsed')\n}\n// check if actual categoryData should be collapsible\nif(categoryData.nrOfChildren <= 0){\ncategoryDataAdditionalClasses.push('noChildren')\n}\n}\n%><div class=\"categoryData <%= categoryDataAdditionalClasses.join(' ') %>\" data-category-id=\"<%- category.id %>\" data-category-data-id=\"<%- categoryData.id %>\" data-children=\"<%- Object.keys(categoryData.children).join(',') %>\"><%\nif(supportCollapsibleTags){\n%><button class=\"collapseController\"><%\n%><i class=\"fi fi-collapse open\"></i><%\n%><i class=\"fi fi-collapsed closed\"></i><%\n%></button><%\n}\n%><button class=\"tag\"><%\nif(resourceData.selectParentsGranted || categoryData.nrOfChildren <= 0){\n%><i class=\"fi fi-tag-unselected\"></i><%\n%><i class=\"selected fi fi-tag-selected\"></i><%\n}\n%><%= categoryData.name %><%= (showTagNumbers ? ' [' + categoryData.id + ' @ ' + ((categoryData.resources || {}).parentCategoryDataID || '-') + ']' : '') %><%\n%></button><%\n%></div><%\nlastLevel = level\n}\nfor(l = 1; l < lastLevel; l++){\n%></div><%\n}\n}\n}\n%></section><%\n%></section><%\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\tags\\tagAssignment.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let c, cd, category, categoryData, aT, childCategoryDataID, categoryAdditionalClasses, categoryDataAdditionalClasses, assignedTagAttributes, selected, childSelected, dirty, childDirty, showOption, dirtyTag, dirtyTagID
let turnedOff, turnedOn, turnedOffByInheritance
let preparedAssignedTag
let level, lastLevel, l
// TODO: remove lse specifics from fec base component
const showTagNumbers = helpers.hasAccessTo('usage:show_lse_tag_numbers', 'literature')
const managementGranted = {
category: 		helpers.hasAccessTo('cms_categories:create'),
categoryData: 	helpers.hasAccessTo('cms_categoriesData:create'),
}
const additionalClasses = []
if(resourceData.useNormalDirtyColor){
additionalClasses.push('dirtyColorNormal')
}
if(config.isEnhanced !== false){
additionalClasses.push('isEnhanced')
} else {
additionalClasses.push('isNotEnhanced')
}
if(!resourceData.selectParentsGranted) {
additionalClasses.push('preventSelectParents')
}
const supportCollapsibleTags 	= resourceData.supportCollapsibleTags === true
const maxOpenLevelOnInit 		= resourceData.maxOpenLevelOnInit || 1

    ; __line = 26
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 
if(config.isEnhanced !== false){

    ; __line = 28
    ; __append( helpers.renderSection('enhanced') )
    ; 
}

    ; __line = 30
    ; __append("<section class=\"tagsOnly\">")
    ; 

    ; __line = 31
    ; __append( helpers.renderSection('filter') )
    ; 

    ; __line = 32
    ; __append("<section class=\"content\">")
    ; 
for(c in resourceData.options || []) {
category = resourceData.options[c]
categoryAdditionalClasses = []
if(resourceData.preparedAssignedCategories[category.id]){
preparedAssignedTag = resourceData.preparedAssignedCategories[category.id]
turnedOff = preparedAssignedTag.turnedOff
turnedOn = preparedAssignedTag.turnedOn
turnedOffByInheritance = preparedAssignedTag.turnedOffByInheritance
} else {
preparedAssignedTag = { noData: true }
turnedOff = false
turnedOn = false
turnedOffByInheritance = (resourceData.inheritedCategories || {})[category.id] === false
}
dirty = false
selected = !turnedOff && (!turnedOffByInheritance || turnedOn)
inherited = !turnedOff && !turnedOn
showOption = resourceData.optionalCategories && model.turnedOffTagCategoryManagementGranted
// check if categoryData is selected by dirty resources
if((dirtyTag = model.dirtyAssignedTags[`${category.id}_null`])){
dirty = true
selected = !selected
}
if(selected) 	categoryAdditionalClasses.push('selected');
if(dirty) 		categoryAdditionalClasses.push('dirty');
if(showOption) 	categoryAdditionalClasses.push('showOption');
if(inherited) 	categoryAdditionalClasses.push('inherited');
if((!turnedOff && !turnedOffByInheritance) || model.turnedOffTagCategoryManagementGranted){

    ; __line = 61
    ; __append("<div class=\"category ")
    ; __append(escapeFn( categoryAdditionalClasses.join(' ') ))
    ; __append("\" data-category-id=\"")
    ; __append( category.id )
    ; __append("\" data-category-data-id=\"null\">")
    ; 

    ; __line = 62
    ; __append("<i class=\"unselected fi fi-tagFamily-unselected\"></i>")
    ; 

    ; __line = 63
    ; __append("<i class=\"selected fi fi-tagFamily-selected\"></i>")
    ; 

    ; __line = 64
    ; __append("<i class=\"inherited fi fi-tagFamily-inherited\"></i>")
    ; 

    ; __line = 65
    ; __append(escapeFn( category.name ))
    ; __append(escapeFn( (showTagNumbers ? ' [' + category.id + ']' : '') ))
    ; 
if(managementGranted.categoryData){

    ; __line = 67
    ; __append( include('./tagCategoryAddCategoryDataButton', { model: { categoryID: category.id }}) )
    ; 
}
if(managementGranted.categoryData){

    ; __line = 70
    ; __append( include('./tagCategoryManagementButton', { model: { categoryID: category.id }}) )
    ; 
}

    ; __line = 72
    ; __append("</div>")
    ; 
lastLevel = undefined
for(cd in category.children || []) {
categoryData = category.children[cd]
categoryDataAdditionalClasses = []
dirtyTagID = `${category.id}_${categoryData.id}`
selected = false
childSelected = false
dirty = false
childDirty = false
// check if categoryData is selected by resources
for(aT in resourceData.assignedTags || []) {
assignedTagAttributes = (resourceData.assignedTags[aT] || {}).attributes || {}
if(assignedTagAttributes.categoryID === category.id){
// check if one of the children is selected or not
if(!childSelected){
for(childCategoryDataID in categoryData.children){
if(assignedTagAttributes.categoryDataID == childCategoryDataID){
childSelected = true
break
}
}
}
if(assignedTagAttributes.categoryDataID === categoryData.id){
selected = true
if(childSelected){
break
}
}
}
}
// check if categoryData is selected by dirty resources
if((dirtyTag = model.dirtyAssignedTags[dirtyTagID])){
dirty = true
selected = dirtyTag.type !== 'delete'
}
// check if one of the children is dirty or not
for(childCategoryDataID in categoryData.children){
if(model.dirtyAssignedTags[`${category.id}_${childCategoryDataID}`]){
childDirty = true
break
}
}
if(selected) 	categoryDataAdditionalClasses.push('selected');
if(dirty) 		categoryDataAdditionalClasses.push('dirty');
level = categoryData.level || 0
if(lastLevel){
if(lastLevel > level) {
for(l = lastLevel; l > level; l--){

    ; __line = 121
    ; __append("</div>")
    ; 
}
} else if(lastLevel < level) {

    ; __line = 124
    ; __append("<div class=\"categoryDataContainer\">")
    ; 
}
}
if(supportCollapsibleTags){
// check if next container should be collapsed
if(maxOpenLevelOnInit <= level && !childDirty && !childSelected){
categoryDataAdditionalClasses.push('collapsed')
}
// check if actual categoryData should be collapsible
if(categoryData.nrOfChildren <= 0){
categoryDataAdditionalClasses.push('noChildren')
}
}

    ; __line = 137
    ; __append("<div class=\"categoryData ")
    ; __append(escapeFn( categoryDataAdditionalClasses.join(' ') ))
    ; __append("\" data-category-id=\"")
    ; __append( category.id )
    ; __append("\" data-category-data-id=\"")
    ; __append( categoryData.id )
    ; __append("\" data-children=\"")
    ; __append( Object.keys(categoryData.children).join(',') )
    ; __append("\">")
    ; 
if(supportCollapsibleTags){

    ; __line = 139
    ; __append("<button class=\"collapseController\">")
    ; 

    ; __line = 140
    ; __append("<i class=\"fi fi-collapse open\"></i>")
    ; 

    ; __line = 141
    ; __append("<i class=\"fi fi-collapsed closed\"></i>")
    ; 

    ; __line = 142
    ; __append("</button>")
    ; 
}

    ; __line = 144
    ; __append("<button class=\"tag\">")
    ; 
if(resourceData.selectParentsGranted || categoryData.nrOfChildren <= 0){

    ; __line = 146
    ; __append("<i class=\"fi fi-tag-unselected\"></i>")
    ; 

    ; __line = 147
    ; __append("<i class=\"selected fi fi-tag-selected\"></i>")
    ; 
}

    ; __line = 149
    ; __append(escapeFn( categoryData.name ))
    ; __append(escapeFn( (showTagNumbers ? ' [' + categoryData.id + ' @ ' + ((categoryData.resources || {}).parentCategoryDataID || '-') + ']' : '') ))
    ; 

    ; __line = 150
    ; __append("</button>")
    ; 

    ; __line = 151
    ; __append("</div>")
    ; 
lastLevel = level
}
for(l = 1; l < lastLevel; l++){

    ; __line = 155
    ; __append("</div>")
    ; 
}
}
}

    ; __line = 159
    ; __append("</section>")
    ; 

    ; __line = 160
    ; __append("</section>")
    ; 

    ; __line = 161
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\tags\tagAssignment.ejs

}